import React, { useRef, useEffect, useState } from 'react'
import '../Style/Index.css'
import '../Style/Login.css'
import User from '../Logos/user.svg'
import Lock from '../Logos/lock (1).svg'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import ShowMessage from '../Components/ShowMessage'

function Login(props) {
    const phonenuminput = useRef()
    const phonenumtitle = useRef()
    const passwordinput = useRef()
    const passwordtitle = useRef()
    const LoginBTN = useRef()
    const [ButtonStatus, SetButtonStatus] = useState(false);
    // const [ErrorMessage, SetErrorMessage] = useState()


    const [LoginValues, SetLoginValue] = useState({
        phoneinp: '',
        passwordinp: ''
    })

    useEffect(() => {
        phonenuminput.current.addEventListener("input", () => {
            if (!phonenuminput.current.value.length > 0) {
                LoginBTN.current.disabled = false
            } else {
                LoginBTN.current.disabled = true
            }
        });
        // passwordinput.current.addEventListener("input", () => {
        // });


        phonenuminput.current.addEventListener("focus", () => {
            phonenumtitle.current.style.transform = "translateY(-20px)"
            phonenumtitle.current.style.fontSize = "12px"
            phonenumtitle.current.style.color = "black";

        });
        phonenuminput.current.addEventListener("focusout", () => {
            if (!phonenuminput.current.value.length > 0) {
                phonenumtitle.current.style.transform = "translateY(0px)"
                phonenumtitle.current.style.fontSize = "15px"
                phonenumtitle.current.style.color = "#a7a7a7";
            }

        });



        passwordinput.current.addEventListener("focus", () => {
            passwordtitle.current.style.transform = "translateY(-20px)"
            passwordtitle.current.style.fontSize = "12px"
            passwordtitle.current.style.color = "black"

        });
        passwordinput.current.addEventListener("focusout", () => {
            if (!passwordinput.current.value.length > 0) {
                passwordtitle.current.style.transform = "translateY(0px)"
                passwordtitle.current.style.fontSize = "15px"
                passwordtitle.current.style.color = "#a7a7a7";
            }

        });
    }, []);


    const Handle_Changes = (e) => {
        SetLoginValue({...LoginValues, [e.target.name]:[e.target.value]})
    }

    const handle_login = (e) => {
        e.preventDefault()
        // if (LoginValues.phoneinp === "" || LoginValues.passwordinp === "") {
        //     SetErrorMessage("لطفا فرم هارا پر کنید")
        //     setTimeout(() => {
        //         SetErrorMessage(null)
        //     }, 9000);
        // } else {
        axios.post('http://127.0.0.1:3001/login', LoginValues)
        .then(data => {
            if (data.data.Can_Login) {
                sessionStorage.setItem("user_id", data.data.ID)
            }
        })
        .catch(err => console.log(err))
        // }
    }

    return (
        <>
            {/* {ErrorMessage? <ShowMessage TypeOfError={"Error"} ErrorMessage={ErrorMessage} /> : null} */}
            <form onSubmit={(e) => handle_login(e)} className='login-section-contianer'>
                <div className='title'>ورود</div>
                <div className='inputs-container'>
                    <div className='phone-num-input-container'>
                        <img src={User} className='user-icon'/>
                        <div className='title' ref={phonenumtitle}>شماره موبایل یا ایمیل</div>
                        <input type='text' name='phoneinp' onChange={(e) => {Handle_Changes(e)}} ref={phonenuminput} />
                    </div>
                    <div className='password-input-contianer'>
                        <img src={Lock} className='lock-icon'/>
                        <div className='title' ref={passwordtitle}>رمز عبور</div>
                        <input type='password' name='passwordinp' onChange={(e) => {Handle_Changes(e)}} ref={passwordinput} />
                        <Link to={'/reset-password'} className='reset-password-text'>فراموشی رمز عبور؟ </Link>
                    </div>
                </div>
                <button type='submit' className='login-button' ref={LoginBTN} onClick={() => {console.log("test")}}>ورود</button>
                <div className='change-to-signup' onClick={() => {props.OnFormSwitch()}}>ساخت حساب کاربری</div>

                {/* <ErrorMessage ErrorMessage={"مشکل در اتصال به سرور"} TypeOfError={"Error"}/> */}
            </form>
        </>
    )
}

export default Login